// Apple은 최초 인증 1회에만 이름/이메일을 내려준다.
// 네이티브 브릿지(getAppleAuthCode)로 받은 값을 회원가입 화면까지 넘기기 위한 임시 보관소.
// 개인정보라 URL 쿼리에는 싣지 않고 sessionStorage로만 전달한다.
const APPLE_SIGNUP_HINT_KEY = 'apple-signup-hint';

interface IAppleSignupHint {
    name: string;
    email: string;
}

const emptyHint: IAppleSignupHint = { name: '', email: '' };

const normalize = (value?: string) => (value ?? '').trim();

const saveAppleSignupHint = (name?: string, email?: string) => {
    const hint: IAppleSignupHint = { name: normalize(name), email: normalize(email) };
    // 빈 값이 왔다고 그냥 빠져나가면 직전 계정의 hint가 남아 다음 로그인 화면에 채워진다.
    // Apple은 두 번째 로그인부터 이름을 주지 않으므로 계정이 바뀌면 반드시 이 경로를 탄다.
    if (!hint.name && !hint.email) {
        clearAppleSignupHint();
        return;
    }
    try {
        sessionStorage.setItem(APPLE_SIGNUP_HINT_KEY, JSON.stringify(hint));
    } catch (error) {
        console.error('error', error);
    }
}

const getAppleSignupHint = (): IAppleSignupHint => {
    try {
        const stored = sessionStorage.getItem(APPLE_SIGNUP_HINT_KEY);
        if (!stored) return emptyHint;
        const parsed = JSON.parse(stored);
        return { name: normalize(parsed?.name), email: normalize(parsed?.email) };
    } catch (error) {
        console.error('error', error);
        return emptyHint;
    }
}

const clearAppleSignupHint = () => {
    try {
        sessionStorage.removeItem(APPLE_SIGNUP_HINT_KEY);
    } catch (error) {
        console.error('error', error);
    }
}

export { saveAppleSignupHint, getAppleSignupHint, clearAppleSignupHint };
export type { IAppleSignupHint };
